import Immutable from "immutable";
import { call, select, put, take } from "redux-saga/effects";
import exactMath from "exact-math";

import {
  getStudentSchoolID,
  getShopItemByID,
  isShopReady,
  getBasketItemsOfType,
  getBasketItemByID
} from "state/school_money/selectors";
import {
  setBasketItem,
  deleteBasketItem,
  setShopItemBasketQuantity
} from "state/school_money/actions";

import validateBasketItem from "state/school_money/sagas/basketSaga/shopItem/validateBasketItem";

function formatBasketItemID(studentID, shopItemID) {
  return `${studentID}:${shopItemID}`;
}

export function* setBasketQuantity(action) {
  const { shopItemID, studentID, quantity } = action.payload;

  const shopItem = yield select(getShopItemByID, shopItemID);
  const schoolID = yield select(getStudentSchoolID, studentID);
  const basketItemID = formatBasketItemID(studentID, shopItemID);
  const payload = { shopItemID, studentID, quantity, shopItem };
  const price = exactMath.mul(quantity, shopItem.get("price"));

  yield put(setBasketItem("shopItem", basketItemID, schoolID, studentID, basketItemID, price, quantity, payload));

}

export function* removeFromBasket(action) {
  const { shopItemID, studentID } = action.payload;
  const basketItemID = formatBasketItemID(studentID, shopItemID);
  yield put(deleteBasketItem("shopItem", basketItemID));
}

export function* detectBasketItemsIssues() {

  // wait for payments to be loaded
  while (!(yield select(isShopReady))) {
    yield take();
  }

  // get relevant state
  const basketItems = yield select(getBasketItemsOfType, "shopItem");

  // build up a list of issues
  let issues = Immutable.List();
  for (const basketItem of basketItems) {
    const issue = yield call(validateBasketItem, basketItem);
    if (issue) {
      issues = issues.push(issue);
    }
  }

  return issues;

}

export function* resolveBasketItemsIssues(issues) {

  if (issues === undefined) {
    return;
  }

  for (const issue of issues) {

    const { basketItemID, reason } = issue.toObject();

    // if insufficient stock then amend the quantity in basket
    if (reason === "insufficient_stock") {

      // get basket item and shop item
      const basketItem = yield select(getBasketItemByID, "shopItem", basketItemID);
      const shopItemID = basketItem.getIn(["payload", "shopItemID"]);
      const shopItem = yield select(getShopItemByID, shopItemID);

      const { studentID } = basketItem.toObject();
      const { quantity } = shopItem.toObject();
      yield put(setShopItemBasketQuantity(shopItemID, studentID, quantity));

    } else {
      // otherwise just delete the basket item
      yield put(deleteBasketItem("shopItem", basketItemID));
    }
  }

}



// WEBPACK FOOTER //
// ./src/state/school_money/sagas/basketSaga/shopItem/index.js